import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

export type TPaymentIcon = 'mc' | 'amex' | 'visa' | 'maestro' | 'paypal' | 'apple' | 'google' | 'klarna';

@Component({
    selector: 'payment-icon',
    templateUrl: 'payment-icon.html',
    styleUrls: ['payment-icon.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class PaymentIconComponent implements OnChanges {
    @Input()
    method?: TPaymentIcon;

    ngOnChanges(): void {
        if (this.method) {
            this.method = this.method.toLowerCase() as TPaymentIcon;
            const as = { vi: 'visa' }[this.method];
            if (as) {
                this.method = as;
            }
        }
    }
}
